module.exports = __webpack_public_path__ + "img/LT112040548.c6a7912e.png";